export default __webpack_public_path__ + "img/AI-Remove.40d463d6.jpg";